import { UpdateReport } from 'src/api';
import { handleErrorToast } from 'src/components/molecules';

export const checkDraftReportIsValid = (currentReport: UpdateReport) => {
  if (!currentReport.reportedCategory) {
    handleErrorToast({
      toastMessage: 'Reported category is required',
    });
    return false;
  } else if (
    !currentReport.evidence?.events ||
    currentReport.evidence?.events.length === 0
  ) {
    handleErrorToast({
      toastMessage: 'At least one event must be included in the report',
    });
    return false;
  } else if (
    !currentReport.evidence?.evidence ||
    currentReport.evidence?.evidence.filter(
      (e) => e.type === '@evidence/description',
    ).length === 0
  ) {
    handleErrorToast({
      toastMessage:
        'A description of what happened must be provided for at least one event',
    });
    return false;
  }

  return true;
};
